module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("absolute top-0 right-0 rounded-r w-10 h-10 flex items-center justify-center bg-gray-100 border text-gray-600 zoom-in cursor-pointer " + _vm.classes),
    on: {
      "click": function($event) {
        return _vm.CopyClipboard(_vm.text)
      }
    }
  }, [_c('a', [_c('Icon', {
    attrs: {
      "name": "copy",
      "classname": "w-6 h-6"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c80b597a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/partials/Copy.vue
// module id = 473
// module chunks = 1